module.exports = __webpack_public_path__ + "img/picto-nbre-pieces.6a3e0a6d.svg";